import { basePath } from './basePath';

const BASE_URL = 'https://www.zlawyer.fr';
const SITE_URL = `${BASE_URL}${basePath}`;
const LOGO_URL = `${SITE_URL}/images/adaptative/zlawyer.svg`;

export const ORGANIZATION_SCHEMA = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'zLawyer',
  url: `${SITE_URL}/`,
  logo: LOGO_URL,
  description:
    "Logiciel de gestion et de facturation pour cabinets d'avocats, depuis 2006. Facturation électronique, gestion des clients, reporting.",
  email: 'info@zele-solutions.fr',
  telephone: '+33184257027',
  foundingDate: '2006',
  contactPoint: {
    '@type': 'ContactPoint',
    telephone: '+33184257027',
    contactType: 'customer support',
    availableLanguage: 'French',
  },
  address: {
    '@type': 'PostalAddress',
    addressCountry: 'FR',
  },
};

export const SOFTWARE_APPLICATION_SCHEMA = {
  '@context': 'https://schema.org',
  '@type': 'SoftwareApplication',
  name: 'zLawyer',
  operatingSystem: 'Web',
  applicationCategory: 'BusinessApplication',
  description:
    "Solution complète de gestion et facturation pour cabinets d'avocats : facturation électronique, gestion clients, reporting financier.",
  url: `${SITE_URL}/`,
  screenshot: `${SITE_URL}/ogImage.webp`,
  inLanguage: 'fr-FR',
  publisher: {
    '@type': 'Organization',
    name: 'zLawyer',
    url: `${SITE_URL}/`,
  },
};

export type ArticleSchemaParams = {
  title: string;
  description: string;
  slug: string;
  date: string;
};

export function buildArticleSchema({
  title,
  description,
  slug,
  date,
}: ArticleSchemaParams): object {
  const articleUrl = `${SITE_URL}/newsletters/${slug}/`;
  return {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: title,
    description,
    datePublished: date,
    dateModified: date,
    inLanguage: 'fr-FR',
    url: articleUrl,
    mainEntityOfPage: { '@type': 'WebPage', '@id': articleUrl },
    author: { '@type': 'Organization', name: 'zLawyer', url: `${SITE_URL}/` },
    publisher: {
      '@type': 'Organization',
      name: 'zLawyer',
      logo: { '@type': 'ImageObject', url: LOGO_URL },
    },
    image: `${SITE_URL}/ogImage.webp`,
  };
}

export type ItemListSchemaItem = {
  title: string;
  slug: string;
  position: number;
};

export function buildNewsletterListSchema(items: ItemListSchemaItem[]): object {
  return {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    name: 'Newsletters zLawyer',
    description:
      "Actualités produit, guides pratiques et mise en conformité pour cabinets d'avocats.",
    url: `${SITE_URL}/newsletters/`,
    itemListElement: items.map(({ title, slug, position }) => ({
      '@type': 'ListItem',
      position,
      name: title,
      url: `${SITE_URL}/newsletters/${slug}/`,
    })),
  };
}
